// Saga for Master Time Frame Interval

import { call, put, all, takeEvery } from "redux-saga/effects";

import { GET_MASTER_TIME_FRAME_INTERVAL_LIST } from "./actionType";

import {
  getMasterTimeFrameIntervalListSuccess,
  getMasterTimeFrameIntervalListFailure,
} from "./action";

import { getMasterTimeFrameIntervalListApi } from "../../helpers/fakebackend_helper";

// Get Master Time Frame Interval List Saga
function* getMasterTimeFrameIntervalListSaga() {
  try {
    const response = yield call(getMasterTimeFrameIntervalListApi);
    yield put(getMasterTimeFrameIntervalListSuccess(response));
  } catch (error) {
    yield put(getMasterTimeFrameIntervalListFailure(error));
  }
}

// Watcher Saga
function* watcherGetMasterTimeFrameIntervalList() {
  yield all([
    takeEvery(
      GET_MASTER_TIME_FRAME_INTERVAL_LIST,
      getMasterTimeFrameIntervalListSaga
    ),
  ]);
}

// Saga Main function
export default function* MasterTimeFrameInterval() {
  yield all([watcherGetMasterTimeFrameIntervalList()]);
}
